import {
    TableViewStore,
    BaseListViewStore,
    DateRangeQueryPickerStore,
    BaasicDropdownStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {ImportService} from 'application/import/services';
import {FacilityService} from 'application/facility/services';
import _ from 'lodash';
import { toDate, uuid } from 'core/utils';
import { resolveColumns } from '../../facility/util/resolveColumns';
import { action, observable } from 'mobx';
import React from "react";

@applicationContext
class ImportViewStore extends BaseListViewStore {
    @observable accessor validationReportUrl = null;
    constructor(rootStore) {
        const service = new ImportService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'import',
            autoInit: true,
            authorization:{
                delete: 'portalSection.delete'
            },
            routes: {
                details: item => {
                    this.setChildNavigationTitle(i => i.id === item.id, item => item.fileName);
                    this.rootStore.routerStore.goTo(
                        'master.app.main.import.detail.list',
                        { id: item.id, facility: item.facility}
                    );
                },
                create: () => {
                    this.rootStore.routerStore.goTo(
                        'master.app.main.import.create',
                    );
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find(_.extend(params, {embed: 'ImportHeaderStatus,CoreUser,Facility,MarketingRep'}));
                        const res =  _.extend(response.data,
                        {
                            item: _.map(response.data.item, (item => {
                                return _.extend(
                                    item, {
                                        coreUser: item.coreUser.firstName + ' ' + item.coreUser.lastName,
                                        facility: item.facility.name,
                                        status: item.importHeaderStatus.name,
                                        dateCreated: toDate(item.dateCreated),
                                        scheduledDate: toDate(item.scheduledDate),
                                        ifFirst: item.isFirst,
                                        facilityId: item.facility.id,
                                        marketingRep: item.marketingRep && item.marketingRep.fullName
                                    }
                                );
                            }))
                        });

                        this.onFindSuccess();
                        return res;
                    },
                    delete: async (item) => {
                        await service.remove(item);
                    }
                }
            }
        });

        const userRoles = this.rootStore.userStore.user.roles;
        this.isAdmin = userRoles.includes("Administrators");

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'fileName',
                    title: 'IMPORT.LIST.COLUMNS.FILE_NAME',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.fileName}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.fileName}
                                    </div>
                                )
                                }
                            </td>
                        )
                    }
                },
                {
                    key: 'numberOfLines',
                    title: 'IMPORT.LIST.COLUMNS.NUMBER_OF_LINES',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.numberOfLines}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.numberOfLines}
                                    </div>
                                )
                                }
                            </td>
                        )
                    },
                    width: 160
                },
                {
                    key: 'dateCreated',
                    title: 'IMPORT.LIST.COLUMNS.DATE_UPLOADED',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.dateCreated}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.dateCreated}
                                    </div>
                                )
                                }
                            </td>
                        )
                    },
                    width: 150
                },
                {
                    key: 'coreUser',
                    title: 'IMPORT.LIST.COLUMNS.USER',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.coreUser}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.coreUser}
                                    </div>
                                )
                                }
                            </td>
                        )
                    }
                },
                {
                    key: 'facility',
                    title: 'IMPORT.LIST.COLUMNS.FACILITY',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.facility}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.facility}
                                    </div>
                                )
                                }
                            </td>
                        )
                    }
                },
                {
                    key: 'marketingRep',
                    title: 'IMPORT.LIST.COLUMNS.MARKETING_REP',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.marketingRep}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.marketingRep}
                                    </div>
                                )
                                }
                            </td>
                        )
                    },
                    width: 150
                },
                {
                    key: 'scheduledDate',
                    title: 'IMPORT.LIST.COLUMNS.SCHEDULED_DATE',
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.scheduledDate}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.scheduledDate}
                                    </div>
                                )
                                }
                            </td>
                        )
                    },
                    width: 150
                },
                {
                    key: 'status',
                    title: 'IMPORT.LIST.COLUMNS.STATUS',
                    sort: false,
                    cell: (item) => {
                        const isFirst = item.dataItem.isFirst;
                        return (
                            <td className="c-pointer table--clickable" key={uuid()} onClick={() => {this.routes.details(item.dataItem)}}>
                                {isFirst ? (
                                    <div className="type--left" key={uuid()} style={{color:"darkred", fontStyle:"italic"}}>
                                        {item.dataItem.status}
                                    </div>
                                ) :
                                (
                                    <div className="type--left" key={uuid()}>
                                        {item.dataItem.status}
                                    </div>
                                )
                                }
                            </td>
                        )
                    },
                    width: 100
                }
            ]),
            actions: {
                onPreview: (item) => this.routes.details(item),
                onDelete: (item) => this.deleteResource(item),
                onEdit: (item) => this.changeIsFirst(item),
                isAdmin: this.isAdmin
            }
        }));

        this.queryUtility.onResetFilter = ()=>{
            this.userStore.setValue(null);
            this.userStore.filterTerm = "";

            this.facilityStore.setValue(null);
            this.facilityStore.filterTerm = "";

            this.importStatusStore.setValue(null);
            this.rangeQueryPickerStore.reset();
        }

        this.rangeQueryPickerStore = new DateRangeQueryPickerStore();
        this.service = service;

        this.userStore = new BaasicDropdownStore({
            filterable: true,
            textField: 'name'
        }, {
            fetchFunc: async(term) => {
                const response = await service.getImportUsers(term);
                return _.map(response.item, user => {
                    return {
                        id: user.id,
                        name: `${(user.firstName || '')} ${(user.lastName || '')}`
                    };
                })
            }
        });

        this.facilityStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async(term) => {
                const response = await facilityService.find({ searchQuery: term, rpp: 450, inActive: false });
                return response.data.item;
            }
        });

        this.importStatusStore = new BaasicDropdownStore({}, {
            fetchFunc: async() => {
                const response = await service.getStatus();
                return response.item.filter(i => i.name === 'Uploaded' || i.name === 'Processing');
            }
        });
    }

    @action.bound
    filterOnChange(store) {
       store.filterTerm = "";
    }

    @action.bound
    async changeIsFirst(item) {
        if(!item.isFirst)
        {
            this.loaderStore.suspend();
            var resource = { id: item.id, isFirst: !item.isFirst, facilityId: item.facilityId };
            await this.service.changeIsFirst(resource);
            if(!item.isFirst)
            {
                this.rootStore.notificationStore.success('Successfully changed');
            }
            await this.queryUtility.fetch();
            this.loaderStore.resume();
        }
    }

    @action.bound
    onFindSuccess() {
		const parameters = this.queryUtility.plainFilter;
		this.validationReportUrl = `${this.service.getValidationReportUrl(parameters)}&contentDisposition=attachment&token=${
            this.rootStore.authStore.token.tokenUrl
        }&ttype=${
            this.rootStore.authStore.token.type}`;
	}
}

export default ImportViewStore;
